import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import 'rxjs/add/operator/map';
import { configURI } from '../../../shared/apiUrlConfig';
import {
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse,
  HttpHandler,
  HttpEvent
} from '@angular/common/http';
import { catchError } from 'rxjs/operators/catchError';
import { _throw } from 'rxjs/observable/throw';
import { UserFriendlyMsgs } from '../../app.user-msgs';
import { environment } from '../../../environments/environment';

@Injectable()
export class ChangeLogService {
  url = environment.configURI;
  private categories = "/documents/GetCategoryByRoleValue?roleValue="
  private docsUrl = "/documents/GetDocumentTypesByCategory?Category="
  private documentTypes = "/changelogs?documentType="
  private logs = "/logDetails"
  constructor(private httpClient: HttpClient, private userFriendlyMsgs: UserFriendlyMsgs) { }

  getCategoryByRoleValue(roleValue){
    return this.httpClient.get(`${this.url}${this.categories}${roleValue}`).catch(this.userFriendlyMsgs.errorHandler);
  }

  docsByCategory(categorySelected){
    return this.httpClient.get(`${this.url}${this.docsUrl}${categorySelected}`).catch(this.userFriendlyMsgs.errorHandler);
  }

  getLogsList(docTypeSelected):any{
    let vendorId = localStorage.getItem("AgentId");
    let agentToggleSelected = localStorage.getItem('agentClicked');
    let parToggleSelected = localStorage.getItem('parClicked');
    if (agentToggleSelected === "false") {
      vendorId = undefined;
    }

    if(vendorId !== "0" && (agentToggleSelected == 'true'|| agentToggleSelected === undefined || vendorId != undefined)){
        return this.httpClient.get(`${this.url}${this.documentTypes}${docTypeSelected}${"&category="}${localStorage.getItem('Category')}${"&vendorId="}${vendorId}`).catch(this.userFriendlyMsgs.errorHandler);
    }
    else if(parToggleSelected === undefined || parToggleSelected == 'true' || parToggleSelected == null){
      return this.httpClient.get(`${this.url}${this.documentTypes}${docTypeSelected}${"&category="}${localStorage.getItem('Category')}`).catch(this.userFriendlyMsgs.errorHandler);
    }
  }

  sendLogs(body){
    return this.httpClient.post(`${this.url}${this.logs}`, body).catch(this.userFriendlyMsgs.errorHandler);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/change_log/change-log.service.ts